/* eslint-disable @angular-eslint/prefer-inject */
import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnDestroy, Output, ViewChild } from '@angular/core';

import { AuthenticationService } from 'app/core/authentication';
import { DataTrackLabelEnum } from 'app/shared/enums/data-track-label.enum';
import { KhAnalyticsService } from 'app/shared/services/kh-analytics.service';
import { TeacherService } from 'app/teacher/services/teacher.service';
import { StudentGapsLogicalErrorModel } from 'app/teacher/student-gaps/models/student-gaps-logical-error.model';

@Component({
  selector: 'kh-reports-top-gap-component',
  templateUrl: './reports-top-gap-component.component.html',
  styleUrls: ['./reports-top-gap-component.component.less'],
  standalone: false
})
export class ReportsTopGapComponentComponent implements AfterViewInit, OnDestroy {
  @Input() public studentGaps: StudentGapsLogicalErrorModel[] = [];
  @Input() public source!: string;
  @Input() public logicalErrorId!: string;

  @Output() public measureGrowthClicked = new EventEmitter<void>();
  @Output() public viewTeacherSupportClicked = new EventEmitter<string>();

  @ViewChild('focusAreaAnchor', { static: false }) public focusAreaAnchorElement!: ElementRef<Element>;

  public showAllGaps = false;
  private observer!: IntersectionObserver;

  public constructor(
    private readonly khAnalyticsService: KhAnalyticsService,
    private readonly authService: AuthenticationService,
    private readonly teacherService: TeacherService
  ) {}

  public ngAfterViewInit(): void {
    this.initializeObserver();
  }

  public ngOnDestroy(): void {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  public onViewTeacherSupportClick(logicalErrorId: string): void {
    this.viewTeacherSupportClicked.emit(logicalErrorId);
  }

  public toggleGaps() {
    this.showAllGaps = !this.showAllGaps;
  }

  private initializeObserver(): void {
    const classId = this.teacherService.activeClassId;
    this.observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.khAnalyticsService.trackEvent({
              eventType: DataTrackLabelEnum.TeacherGapReportBlockViewed,
              classId: classId,
              jsonData: {
                source: this.source,
                logicalErrorId: this.logicalErrorId
              },
              userId: this.authService.getUserClaims().userId
            });

            this.observer.disconnect();
          }
        });
      },
      { threshold: 0.1 }
    );

    if (this.focusAreaAnchorElement && this.focusAreaAnchorElement.nativeElement) {
      this.observer.observe(this.focusAreaAnchorElement.nativeElement);
    }
  }
}
